import { StoreState } from 'app/models/types';

export const focusedPartSelector = (state: StoreState) => state.ui.focusedPart;
export const openedOverlaySelector = (state: StoreState) => state.ui.openedOverlay;
export const loadingSelector = (state: StoreState) => state.ui.loading;
